import styled from "styled-components";
// @ts-ignore
import buildColor from "@fdr/static-ui/ColorPalette";
// @ts-ignore
import { fontNormal } from "@fdr/static-ui/Typography";

export const ErrorListWrapper = styled.div``;

export const Title = styled.h2`
  color: ${buildColor("white")};
  font-family: ${fontNormal};
  font-size: 18px;
  line-height: 22px;
  font-weight: 700;
`;

export const MessageBlock = styled.div`
  background-color: ${buildColor("navy", "D1")};
  color: ${buildColor("white")};
  font-family: ${fontNormal};
  font-size: 14px;
  line-height: 22px;
  border-radius: 4px;
  padding: 12px 16px;
  margin-top: 16px;
`;

export const TitleMessage = styled.p`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  & > svg {
    margin-right: 8px;
  }
`;
